module.exports = __webpack_public_path__ + "img/ganzhi2.33149e77.svg";